import React, { useRef } from 'react';

interface ImageInputButtonProps {
  onImageSelected: (file: File) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * 图片输入浮动按钮组件
 * 圆形按钮，支持拍照和上传图片
 */
export const ImageInputButton: React.FC<ImageInputButtonProps> = ({
  onImageSelected,
  disabled = false,
  className = ''
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (disabled) return;
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type.startsWith('image/')) {
      onImageSelected(file);
      // 清空input，允许重复选择同一文件
      e.target.value = '';
    }
  };

  return (
    <>
      <button
        onClick={handleButtonClick}
        disabled={disabled}
        className={`
          fixed bottom-24 right-6 z-50
          w-14 h-14 rounded-full
          bg-gradient-to-br from-purple-500 to-indigo-600
          hover:from-purple-600 hover:to-indigo-700
          shadow-lg hover:shadow-xl
          flex flex-col items-center justify-center
          transition-all duration-300
          disabled:opacity-50 disabled:cursor-not-allowed
          group
          ${className}
        `}
        title="发送图片"
      >
        <svg 
          className="w-6 h-6 text-white" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
          />
        </svg>
        <span className="text-[10px] text-white font-medium mt-0.5">图片</span>
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFileChange}
        className="hidden"
      />
    </>
  );
};

export default ImageInputButton;
